const Partners = () => {
  const logoList = [
    "/images/part1.png",
    "/images/part2.png",
    "/images/part3.png",
    "/images/part4.png",
    "/images/part5.png",
    "/images/part6.png",
    "/images/part7.png",
    "/images/part8.svg",
    "/images/part9.png",
    "/images/part10.png",
    "/images/part11.png",
    "/images/part12.png",
    "/images/part13.png",
    "/images/part14.png",
    "/images/part15.png",
    "/images/part16.png",
    "/images/part17.svg",
    "/images/part18.png",
    "/images/part19.png",
    "/images/part20.png",
  ];
  return (
    <div
      id="partners"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] max-w-[var(--container-width)] mx-auto  py-14 lg:py-28"
    >
      <div id="title" className="relative w-full h-fit text-center mb-10">
        <div className="relative w-full h-fit">
          <h2 className="leading-none gmedium">몽땅의&nbsp;협력업체</h2>
          <h4 className="text-secondary mt-2 gmedium">
            -&nbsp;PARTNERS&nbsp;-
          </h4>
        </div>
      </div>
      <div className="relative w-full h-fit grid grid-cols-3 lg:grid-cols-5 gap-2 lg:gap-5">
        {logoList.map((v, i) => (
          <div
            key={i}
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay={i * 100 + 100}
            className={
              i > 14
                ? "hidden lg:block relative w-full h-full border px-3 py-6"
                : "relative w-full h-full border xs:px-3 py-6"
            }
          >
            <img
              className="!relative w-auto max-w-20 h-5 xs:h-8 lg:max-w-32 lg:h-14 mx-auto object-contain"
              alt="logo"
              src={v}
              width={500}
              height={500}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Partners;
